export const ItemTypes = {
    LAYOUT: 'layout',
    ELEMENT: 'element',
    MOVE: 'move',
    ROW_MOVE: 'row_move',
    SECTION_MOVE:'section_move',
    ELEMENT_MOVE:'element_move',
    FORM_DRAG:'form_drag',
    FORM_MOVE:'form_move',
    PREVIEW_PANEL_MOVE: 'preview_panel_move',
  }
